module.exports = __webpack_public_path__ + "static/img/King of Wands.49a906d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/King of Wands.jpg
// module id = 1278
// module chunks = 0